import {Flex} from 'exsportia-components'
import {FC, ReactElement} from 'react'
import {Navigate, useParams} from 'react-router-dom'

import {useAppearanceEntityLookup} from '../../../api/helpers/data'
import {Loader} from '../../../ui/components/loader/loader'

// Renders the booking form only once the venue's appearance template has settled, so the form finds
// its instructor / service on the first render — on a direct deep link, and on a link from a group
// venue's page into one of its children. An entity the template does not know sends the visitor to
// the venue root on purpose, without an exception.
export const AppearanceEntityGate: FC<{entityParams: string[]; children: ReactElement}> = ({entityParams, children}) => {
  const params = useParams<Record<string, string>>()
  const {isReady, find} = useAppearanceEntityLookup(params.venueId)
  const ids = entityParams.map((name) => params[name]).filter(Boolean) as string[]
  if (!params.venueId || ids.length === 0) {
    return null
  }
  if (!isReady) {
    return (
      <Flex justifyContent='center' p='48px 0'>
        <Loader />
      </Flex>
    )
  }
  if (ids.some((id) => !find(id))) {
    return <Navigate to={`/${params.venueId}`} replace />
  }
  return children
}
